import { useId } from "react";
import type { QuestionProps } from "../types";
import { QuestionShell } from "./QuestionShell";
import { Input } from "@/components/ui/input";

export function ShortText(props: QuestionProps) {
  const id = useId();
  const { value, onChange, disabled } = props;
  return (
    <QuestionShell props={props} inputId={id}>
      {({ helpId }) => (
        <Input
          id={id}
          aria-describedby={helpId}
          value={typeof value === "string" ? value : ""}
          disabled={disabled}
          maxLength={10000}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </QuestionShell>
  );
}
